"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, privateMap) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to get private field on non-instance");
    }
    return privateMap.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, privateMap, value) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to set private field on non-instance");
    }
    privateMap.set(receiver, value);
    return value;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _client, _customerKey, _customerSecret, _accessTokenTimeoutHalfExpirationId, _accessTokenTimeoutThreeQuarterExpirationId, _accessTokenTimeoutExpiredId, _participant;
Object.defineProperty(exports, "__esModule", { value: true });
exports.SessionService = void 0;
const jwt_decode_1 = __importDefault(require("jwt-decode"));
const Service_1 = __importDefault(require("../Service"));
const SessionClient_1 = __importDefault(require("./SessionClient"));
const VoxeetApi_1 = __importDefault(require("../../api/VoxeetApi"));
const Participant_1 = require("../../models/Participant");
const VoxeetSDK_1 = __importDefault(require("../../VoxeetSDK"));
const EventBusInstance_1 = __importDefault(require("../../events/EventBusInstance"));
const SessionOpened_1 = __importDefault(require("../../events/session/SessionOpened"));
const SessionClosed_1 = __importDefault(require("../../events/session/SessionClosed"));
const Exceptions_1 = require("../../lib/Exceptions");
/**
 *
 * The SessionService allows [opening](#open) and [closing](#close) sessions. Opening a session is mandatory before interacting with any service.
 *
 * ---
 *
 * @noInheritDoc
 */
class SessionService extends Service_1.default {
    /**
     * @ignore
     * @param sdk
     */
    constructor(sdk) {
        super(sdk);
        /**
         * @ignore
         */
        this.wsHost = __WS_HOST__;
        // The websocket client
        _client.set(this, void 0);
        _customerKey.set(this, void 0);
        _customerSecret.set(this, void 0);
        _accessTokenTimeoutHalfExpirationId.set(this, void 0);
        _accessTokenTimeoutThreeQuarterExpirationId.set(this, void 0);
        _accessTokenTimeoutExpiredId.set(this, void 0);
        _participant.set(this, void 0);
    }
    /**
     * Getting an access token from voxeet servers.
     * @ignore
     */
    register() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!VoxeetApi_1.default.accessToken) {
                if (!this.customerKey || !this.customerSecret) {
                    throw new Error('Uninitialized VoxeetSDK');
                }
                VoxeetApi_1.default.tokenCallback = this.refreshToken.bind(this);
                const { data: { access_token, refresh_token }, } = yield VoxeetApi_1.default.init.register({
                    headers: {
                        Authorization: 'Basic ' + btoa(encodeURI(__classPrivateFieldGet(this, _customerKey)) + ':' + encodeURI(__classPrivateFieldGet(this, _customerSecret))),
                    },
                    data: {
                        grant_type: 'client_credentials',
                    },
                });
                VoxeetApi_1.default.accessToken = access_token && access_token;
                VoxeetApi_1.default.refreshToken = refresh_token && refresh_token;
                VoxeetApi_1.default.leavingCallback = () => {
                    VoxeetSDK_1.default.conference.leave();
                };
            }
            this.startAccessTokenExpirationTimeouts();
        });
    }
    /**
     * Opens a new session.
     *
     * @param info - The optional information about the local participant.
     */
    open(info = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            if (__classPrivateFieldGet(this, _client)) {
                // a session is already opened, throw an exception
                throw new Exceptions_1.SessionError('A session has already been opened');
            }
            yield this.register();
            const data = info;
            data.sdkVersion = VoxeetSDK_1.default.version; // Providing version
            let res = yield VoxeetApi_1.default.init.identify({ data });
            __classPrivateFieldSet(this, _participant, new Participant_1.Participant(res.data.user_id));
            __classPrivateFieldGet(this, _participant).info = info;
            // local participants do not receive their own audio
            __classPrivateFieldGet(this, _participant).updateAudioReceivingStopped(true);
            //VoxeetApi.accessToken = r.data.user_token;
            VoxeetApi_1.default.jwtToken = res.data.jwt_user_token;
            // see CCS-1837
            VoxeetApi_1.default.wsHost = VoxeetSDK_1.default.flavor === 'devssl' && res.data.wsUri.startsWith('wss://ws') ? VoxeetApi_1.default.wsHost : res.data.wsUri;
            //Opening websocket
            __classPrivateFieldSet(this, _client, new SessionClient_1.default(VoxeetApi_1.default.wsHost, VoxeetApi_1.default.getHashId(), VoxeetApi_1.default.jwtToken));
            yield __classPrivateFieldGet(this, _client).openSession();
            EventBusInstance_1.default.send(new SessionOpened_1.default());
        });
    }
    /**
     * Closes the current session.
     */
    close() {
        return VoxeetApi_1.default.init.logout().then(() => {
            VoxeetApi_1.default.jwtToken = null;
            __classPrivateFieldSet(this, _participant, null);
            __classPrivateFieldGet(this, _client).closeSession();
            __classPrivateFieldSet(this, _client, null);
            EventBusInstance_1.default.send(new SessionClosed_1.default());
        });
    }
    refreshToken() {
        VoxeetApi_1.default.accessToken = null;
        return VoxeetApi_1.default.init
            .refresh({
            headers: {
                Authorization: 'Basic ' + btoa(encodeURI(__classPrivateFieldGet(this, _customerKey)) + ':' + encodeURI(__classPrivateFieldGet(this, _customerSecret))),
            },
            data: {
                refresh_token: VoxeetApi_1.default.refreshToken,
            },
        })
            .then((r) => {
            VoxeetApi_1.default.accessToken = r.data.access_token;
            return r.data.access_token;
        });
    }
    /**
     * Provides the local participant object that belongs to the current session.
     */
    get participant() {
        return __classPrivateFieldGet(this, _participant);
    }
    get customerKey() {
        return __classPrivateFieldGet(this, _customerKey);
    }
    get customerSecret() {
        return __classPrivateFieldGet(this, _customerSecret);
    }
    /**
     * Refreshes the conference access token.
     * @ignore
     */
    refreshAccessToken() {
        if (VoxeetApi_1.default.getTokenCallback()) {
            // Refresh the token using oauth if a callback is set
            return VoxeetApi_1.default.getTokenCallback()(VoxeetApi_1.default.isTokenExpired()).then((t) => {
                if (!t) {
                    throw Exceptions_1.RefreshTokenError();
                }
                VoxeetApi_1.default.accessToken = t;
                this.startAccessTokenExpirationTimeouts();
            });
        }
        else {
            // Refresh the token using consumerKey/secret
            return this.refreshToken();
        }
    }
    // Function timeout for access token
    accessTokenTimeoutHalfExpiration() {
        VoxeetApi_1.default.getTokenCallback()(VoxeetApi_1.default.isTokenExpired()).then((t) => {
            if (!t) {
                throw Exceptions_1.RefreshTokenError();
            }
            VoxeetApi_1.default.accessToken = t;
            this.startAccessTokenExpirationTimeouts();
        });
    }
    accessTokenTimeoutThreeQuarterExpiration() {
        VoxeetApi_1.default.getTokenCallback()(VoxeetApi_1.default.isTokenExpired()).then((t) => {
            if (!t) {
                throw Exceptions_1.RefreshTokenError();
            }
            VoxeetApi_1.default.accessToken = t;
            this.startAccessTokenExpirationTimeouts();
        });
    }
    accessTokenTimeoutExpired() {
        VoxeetApi_1.default.getTokenCallback()(VoxeetApi_1.default.isTokenExpired()).then((t) => {
            if (!t) {
                throw Exceptions_1.RefreshTokenError();
            }
            VoxeetApi_1.default.accessToken = t;
            VoxeetSDK_1.default.conference.leave();
        });
    }
    /**
     * @ignore
     */
    startAccessTokenExpirationTimeouts() {
        return __awaiter(this, void 0, void 0, function* () {
            const { exp } = jwt_decode_1.default(VoxeetApi_1.default.accessToken);
            clearTimeout(__classPrivateFieldGet(this, _accessTokenTimeoutHalfExpirationId));
            clearTimeout(__classPrivateFieldGet(this, _accessTokenTimeoutThreeQuarterExpirationId));
            clearTimeout(__classPrivateFieldGet(this, _accessTokenTimeoutExpiredId));
            VoxeetApi_1.default.accessTokenExpiration = exp; // - 580; // DEBUG TO BE DELETE !!
            // Refresh token expiration / 2
            __classPrivateFieldSet(// - 580; // DEBUG TO BE DELETE !!
            this, _accessTokenTimeoutHalfExpirationId, setTimeout(this.accessTokenTimeoutHalfExpiration.bind(this), ((VoxeetApi_1.default.accessTokenExpiration - new Date().getTime() / 1000) * 1000) / 2));
            // Refresh token expiration at 3/4
            __classPrivateFieldSet(this, _accessTokenTimeoutThreeQuarterExpirationId, setTimeout(this.accessTokenTimeoutThreeQuarterExpiration.bind(this), ((VoxeetApi_1.default.accessTokenExpiration - new Date().getTime() / 1000) * 1000 * 3) / 4));
            // Refresh token expiration at expiration over, will leave the conference
            __classPrivateFieldSet(this, _accessTokenTimeoutExpiredId, setTimeout(this.accessTokenTimeoutExpired.bind(this), (VoxeetApi_1.default.accessTokenExpiration - new Date().getTime() / 1000) * 1000));
        });
    }
    /**
     * If true, indcates that connection with backend is open.
     */
    isOpen() {
        if (!__classPrivateFieldGet(this, _client)) {
            return false;
        }
        return __classPrivateFieldGet(this, _client).isOpen();
    }
    /**
     * @ignore
     */
    set customerKey(key) {
        __classPrivateFieldSet(this, _customerKey, key);
    }
    /**
     * @ignore
     */
    set customerSecret(secret) {
        __classPrivateFieldSet(this, _customerSecret, secret);
    }
    /**
     * @ignore
     */
    set accessToken(token) {
        VoxeetApi_1.default.accessToken = token;
    }
    /**
     * @ignore
     */
    set refreshCallback(callback) {
        VoxeetApi_1.default.tokenCallback = callback;
    }
}
exports.SessionService = SessionService;
_client = new WeakMap(), _customerKey = new WeakMap(), _customerSecret = new WeakMap(), _accessTokenTimeoutHalfExpirationId = new WeakMap(), _accessTokenTimeoutThreeQuarterExpirationId = new WeakMap(), _accessTokenTimeoutExpiredId = new WeakMap(), _participant = new WeakMap();
